export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { duration: 1.0, ease: "easeOut" },
  },
};

export const slideLeft = {
  hidden: { opacity: 0, x: -40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

export const slideRight = {
  hidden: { opacity: 0, x: 40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

export const mobileMenuVariants = {
  hidden: {
    height: 0,
    opacity: 0,
  },
  show: {
    height: "calc(100vh - 80px)",
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.77, 0, 0.18, 1],
    },
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: {
      duration: 0.4,
      ease: [0.77, 0, 0.18, 1],
    },
  },
};

export const slideUp = {
  hidden: {
    opacity: 0,
    y: 60,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

export const slideRightCard = {
  hidden: {
    opacity: 0,
    x: 60,
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

export const variants = {
  primary: `
    bg-gradient-to-r from-reddark to-redlight
    text-white
    shadow-[0_8px_25px_rgba(139,0,0,0.25)]
    hover:shadow-[0_12px_35px_rgba(139,0,0,0.35)]
  `,
  outline: `
    border border-reddark
    bg-white
    text-reddark
    hover:bg-reddark
    hover:text-white
  `,
};
